import { Icon } from '@chakra-ui/react';

export default function SFCheckmark(props) {
  return (
    <Icon
      width={4}
      height='15px'
      viewBox='0 0 16 15'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M6.41406 14.4453C5.91406 14.4453 5.53906 14.2656 5.20312 13.8672L1.17188 8.98438C0.890625 8.66406 0.789062 8.375 0.789062 8.04688C0.789062 7.3125 1.33594 6.77344 2.09375 6.77344C2.53125 6.77344 2.84375 6.92969 3.13281 7.27344L6.375 11.2969L12.7656 1.21875C13.0781 0.726562 13.3984 0.539062 13.9141 0.539062C14.6641 0.539062 15.2109 1.07031 15.2109 1.80469C15.2109 2.07812 15.125 2.36719 14.9219 2.67969L7.64062 13.8125C7.35938 14.2422 6.94531 14.4453 6.41406 14.4453Z' />
    </Icon>
  );
}
